import { companyNewHirePath } from "@oysterhr/router"
import { Button } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import classNames from "classnames"
import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"

type Props = {
  countryCode: string
  className?: string
  analyticsName?: string
}

export function HireBanner({ countryCode, className, analyticsName }: Props) {
  const { t } = useTranslation("monetization/HireBanner")
  const { isStaff } = useAccountAspect()
  const href = companyNewHirePath("current", countryCode)
  const containerClassNames = classNames(
    "align-items-center flex justify-between rounded-lg bg-gray-100 p-3",
    className,
  )

  return (
    <div className={containerClassNames}>
      <div className="flex flex-col place-content-center text-md font-semibold">
        {t("readyToHire")}
      </div>
      <Button
        disabled={isStaff}
        data-analytics-name={analyticsName || "hire_button_ge_tools_dashboard"}
        data-testid="hire-now-button"
        as="a"
        target="_blank"
        href={href}
      >
        {t("hireNow")}
      </Button>
    </div>
  )
}
